'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.safeMode = exports.retry = exports.validateStatus = exports.reportOptionsError = exports.jsonResponse = exports.responseInterceptor = exports.onResponseError = exports.onResponse = exports.jsonBody = exports.bodyType = exports.standardApi = exports.withApiAsOption = exports.environmentUrl = exports.httpsOnly = exports.withQuery = exports.query = exports.base = exports.header = exports.method = exports.defaultTo = exports.withOptions = exports.withUrl = exports.resolveApi = exports.validateOptions = exports.services = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _enviro = require('enviro');

var _enviro2 = _interopRequireDefault(_enviro);

var _index = require('../index');

var _promise = require('../helpers/promise');

var _update = require('../helpers/update');

var _response = require('../helpers/response');

var _url = require('../helpers/url');

var _params = require('../helpers/params');

var params = _interopRequireWildcard(_params);

var _headers = require('../helpers/headers');

var headers = _interopRequireWildcard(_headers);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// defensive over accessing localStorage because http://meyerweb.com/eric/thoughts/2012/04/25/firefox-failing-localstorage/
var getLocalStorage = function getLocalStorage() {
  try {
    return window.localStorage;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[hub-http] Exception accessing local storage.', error);
    return undefined;
  }
};

var services = exports.services = function services(options) {
  return _extends({
    location: window.location,
    cookies: window.document.cookie,
    localStorage: getLocalStorage(),
    document: window.document
  }, options);
};

var validateOptions = exports.validateOptions = function validateOptions(validator, errorMessage) {
  return function (options) {
    if (!validator || typeof validator !== 'function') {
      throw new Error('validator must be a function');
    }

    if (!validator(options)) throw new Error(errorMessage);

    return options;
  };
};

var resolveApi = exports.resolveApi = function resolveApi(api) {
  var environment = _enviro2.default.getShort('hub-http');
  var location = environment === 'local' ? 'local' : 'deployed';
  var hostname = api[location] ? api[location][environment] : null;
  if (!hostname) {
    throw new Error('No hostname defined for environment ' + environment + ' and ' + location);
  }
  return hostname;
};

var parsedUrl = Symbol('url');

// ensures consistant handling of the parsed url object when making url modifications
// without losing information
var withUrl = exports.withUrl = function withUrl(urlMutator) {
  return function (options) {
    var descriptor = options[parsedUrl] || (0, _url.parseUrl)(options.url);

    descriptor = urlMutator(descriptor);
    options = (0, _update.set)(parsedUrl, descriptor)(options);
    options = (0, _update.set)('url', (0, _url.buildUrl)(descriptor))(options);
    return options;
  };
};

var withOptions = exports.withOptions = function withOptions(options, newOptions) {
  return Object.assign({}, options, newOptions);
};

// TODO: REVIEW
var fromInput = function fromInput(propertyName, options) {
  /**
   * If options.input exists, this is a composed middleware's options, and we want to check if
   * the initial arguments had the property name. Otherwise, there's only one middleware
   * current options === initial options.
   */
  var input = options && options._input ? options._input : options;

  return input[propertyName] !== undefined ? input[propertyName] : undefined;
};

var defaultTo = exports.defaultTo = function defaultTo(propertyName, value) {
  return function (options) {
    return fromInput(propertyName, options) === undefined ? (0, _update.set)(propertyName, value)(options) : options;
  };
};

var method = exports.method = function method(verb) {
  return defaultTo('method', verb);
};

var header = exports.header = function header(name, value, override) {
  return function (options) {
    var headerValue = headers.getHeader(name, options);
    return override || headerValue === undefined ? headers.setHeader(name, value, options) : options;
  };
};

var base = exports.base = function base(baseUrl) {
  return function (options) {
    return (0, _update.set)('url', baseUrl + options.url)(options);
  };
};

var initialQuery = Symbol('initialQuery');
var notOverridableQuery = Symbol('noOverrideQuery');
var overridableQuery = Symbol('overrideQuery');

var query = exports.query = function query(obj) {
  var allowOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  return withUrl(function (url) {
    var descriptor = url;
    if (typeof descriptor[initialQuery] === 'undefined') {
      descriptor = (0, _update.set)(initialQuery, url.query || '')(descriptor);
    }

    var _ref = allowOverride ? [overridableQuery, descriptor[overridableQuery], obj] : [notOverridableQuery, obj, descriptor[notOverridableQuery]],
        _ref2 = _slicedToArray(_ref, 3),
        key = _ref2[0],
        base = _ref2[1],
        superset = _ref2[2];

    descriptor = (0, _update.setIn)([key], _extends({}, base, superset))(descriptor);

    return (0, _update.set)('query', [descriptor[initialQuery], params.stringify(_extends({}, descriptor[overridableQuery], descriptor[notOverridableQuery]))].filter(Boolean).join('&'))(descriptor);
  });
};

var withQuery = exports.withQuery = function withQuery(options) {
  return query(options.query, false)(options);
};

var httpsOnly = exports.httpsOnly = withUrl((0, _update.set)('protocol', 'https'));

var environmentUrl = exports.environmentUrl = function environmentUrl(defaultApi) {
  return function (options) {
    return withUrl(function (url) {
      if (!url.protocol && options.location) {
        url.protocol = options.location.protocol.slice(0, -1);
      }

      if (!url.hostname) {
        var api = options.api || defaultApi;
        url.hostname = resolveApi(api);
      }

      return url;
    })(options);
  };
};

var withApiAsOption = exports.withApiAsOption = function withApiAsOption(options) {
  if (!options.api) {
    throw new Error('Missing api option. Expected api object (you can create one with the standardApi function');
  }

  return environmentUrl(null)(options);
};

var standardApi = exports.standardApi = function standardApi(name, domainPrefix) {
  return {
    local: {
      qa: 'local.' + domainPrefix + 'qa.com',
      prod: 'local.' + domainPrefix + '.com'
    },
    deployed: {
      qa: name + '.' + domainPrefix + 'qa.com',
      prod: name + '.' + domainPrefix + '.com'
    }
  };
};

var bodyType = exports.bodyType = function bodyType(contentType, stringifyFn) {
  return function (options) {
    options = header('content-type', contentType)(options);
    if (options.rawData) {
      options.data = options.rawData;
    } else if (typeof stringifyFn === 'function' && headers.getHeader('content-type', options) === contentType) {
      options.data = stringifyFn(options.data);
    }

    return options;
  };
};

var jsonBody = exports.jsonBody = function jsonBody(options) {
  return (
    // null will stringify to "null", whereas undefined will stringify to ""
    // (a body with content-length: 0), which is invalid json.
    options.data !== undefined || options.rawData !== undefined ? bodyType('application/json', JSON.stringify)(options) : options
  );
};

var wrapResponseHandler = function wrapResponseHandler(handler) {
  return function (response) {
    try {
      return handler(response);
    } catch (error) {
      error.response = response;
      throw error;
    }
  };
};

var onResponse = exports.onResponse = function onResponse(handler) {
  return (0, _response.handleResponse)(function (response) {
    return response.then(wrapResponseHandler(handler));
  });
};

var onResponseError = exports.onResponseError = function onResponseError(handler) {
  return (0, _response.handleResponse)(function (response) {
    return response.catch(wrapResponseHandler(handler));
  });
};

var responseInterceptor = exports.responseInterceptor = function responseInterceptor(handler) {
  var alwaysRejectOnCatch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return (0, _response.handleResponse)(function (response) {
    return response.then(wrapResponseHandler(handler), function (r) {
      return alwaysRejectOnCatch ? _promise.Promise.reject(handler(r)) : handler(r);
    });
  });
};

var getContentType = function getContentType(response) {
  if (!response || !response.headers) return '';
  return headers.getHeader('content-type', response) || '';
};

var jsonResponse = exports.jsonResponse = (0, _index.createStack)(header('Accept', 'application/json, text/javascript, */*; q=0.01'), onResponse(function (response) {
  return (0, _update.setIf)(typeof response.data === 'string' && getContentType(response).indexOf('application/json') === 0, 'data', function () {
    return response.data.length ? JSON.parse(response.data) : undefined;
  })(response);
}));

var reportOptionsError = exports.reportOptionsError = onResponse(function (response) {
  if (response.errorCode === 'OPTIONSERROR') {
    return _promise.Promise.reject((0, _response.responseError)(response, 'hub-http error building request options: ' + response.options.error.message));
  }
  return response;
});

var validateStatus = exports.validateStatus = function validateStatus(options) {
  return onResponse(function (response) {
    return response.status >= 200 && response.status < 300 ? response : _promise.Promise.reject((0, _response.responseError)(response, 'Request for ' + options.url + ' failed with status ' + response.status + '. ' + (response.statusText || '')));
  })(options);
};

var retry = exports.retry = function retry(predicate) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      reason = _ref3.reason,
      _ref3$maxRetries = _ref3.maxRetries,
      maxRetries = _ref3$maxRetries === undefined ? 1 : _ref3$maxRetries,
      _ref3$delay = _ref3.delay,
      delay = _ref3$delay === undefined ? 250 : _ref3$delay,
      onMaxAttemptsReached = _ref3.onMaxAttemptsReached;

  return function (options) {
    var interceptor = function interceptor(response) {
      if (predicate(response)) {
        var responseWithRetryInfo = (0, _update.set)('retry', {
          reason: reason,
          maxRetries: maxRetries,
          delay: delay,
          exceededRetries: response.options.retryAttempts >= maxRetries
        })(response);
        return _promise.Promise.reject(responseWithRetryInfo);
      }

      return response;
    };

    if (maxRetries === 0) {
      // Make the retry middleware a no-op
      return options;
    } else {
      // Intercept the current response to do retries
      var responseMiddleware = options.retryAttempts >= maxRetries && typeof onMaxAttemptsReached === 'function' ? (0, _index.createStack)(onResponse(interceptor), onMaxAttemptsReached) : onResponse(interceptor);
      return responseMiddleware(options);
    }
  };
};

var safeMode = exports.safeMode = (0, _update.set)('safeMode', true);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/hub-http/static-1.161/js/middlewares/core.js
// module id = 18
// module chunks = 0